import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserNoteEntity } from '../../domain/entities/UserNoteEntity'

export class UserNoteModel extends UserNoteEntity {
  constructor(dataDto: UserNoteEntity) {
    super()
    mapEntityProperties<UserNoteModel>(this, dataDto)
  }
}
